const images = {
  404: require('../assets/images/404.png')?.default,
  noData: require('../assets/images/noData.webp')?.default,
  noData2: require('../assets/images/noData2.png')?.default,
  logo_purple: require('../assets/images/logo_purple.png')?.default,
  logo_black: require('../assets/images/logo_black.png')?.default,
  logo_white: require('../assets/images/logo_white.png')?.default,
  icon: require('../assets/images/icon.png')?.default,
  rent_house: require('../assets/images/rent-house.svg')?.default,
  csv: require('../assets/images/icon_file-CSV_plano-512.webp')?.default,
  word: require('../assets/images/word-logo-8.png')?.default,
  excel: require('../assets/images/microsof-excel-logo.png')?.default,
  pdf: require('../assets/images/pdf-icon-png-pdf-zum-download-2.png')?.default,
  powerpoint: require('../assets/images/microsoft-powerpoint-logo.png')?.default,
  agentIllustration: require('../assets/images/agent-illustration.webp')?.default,
  agencyIllustration: require('../assets/images/agency-illustration.webp')?.default,
  loginIllustration: require('../assets/images/login-illustration.webp')?.default,
  registerIllustration: require('../assets/images/register-illustration.webp')?.default,
  createPropertyIllustration: require('../assets/images/create-property-illustration.png')?.default,
  agentIlu: require('../assets/images/agent-illu.png')?.default,
  agentIlu2: require('../assets/images/agent-illu2.png')?.default,
  morgageProcess: require('../assets/images/mortgage-process.webp')?.default
}

export default images
